import React from 'react'

import './root.css'

const Root = props => <div {...props} />

export default Root
